import bottle from "./assets/pics/bottle.svg";
import development_boat from "./assets/pics/development_boat.svg";
import final from "./assets/pics/final.svg";
import launch_boat from "./assets/pics/launch_boat.svg";
import lighthouse from "./assets/pics/lighthouse.svg";
import map_man from "./assets/pics/map_man.svg";

import homeet1 from "./assets/pics/homeet/homeet1.webp";
import homeet2 from "./assets/pics/homeet/homeet2.webp";
import homeet3 from "./assets/pics/homeet/homeet3.webp";
import homeet4 from "./assets/pics/homeet/homeet4.webp";
import homeet1_full from "./assets/pics/homeet/homeet1BIG.webp";
import homeet2_full from "./assets/pics/homeet/homeet2BIG.webp";
import homeet3_full from "./assets/pics/homeet/homeet3BIG.webp";
import homeet4_full from "./assets/pics/homeet/homeet4BIG.webp";

import styleru1 from "./assets/pics/styleru/styleru1.webp";
import styleru2 from "./assets/pics/styleru/styleru2.webp";
import styleru3 from "./assets/pics/styleru/styleru3.webp";
import styleru4 from "./assets/pics/styleru/styleru4.webp";
import styleru1_full from "./assets/pics/styleru/styleru1BIG.webp";
import styleru2_full from "./assets/pics/styleru/styleru2BIG.webp";
import styleru3_full from "./assets/pics/styleru/styleru3BIG.webp";
import styleru4_full from "./assets/pics/styleru/styleru4BIG.webp";

import numislatt1 from "./assets/pics/numislatt/numislatt1.webp";
import numislatt2 from "./assets/pics/numislatt/numislatt2.webp";
import numislatt3 from "./assets/pics/numislatt/numislatt3.webp";
import numislatt4 from "./assets/pics/numislatt/numislatt4.webp";
import numislatt1_full from "./assets/pics/numislatt/numislatt1BIG.webp";
import numislatt2_full from "./assets/pics/numislatt/numislatt2BIG.webp";
import numislatt3_full from "./assets/pics/numislatt/numislatt3BIG.webp";
import numislatt4_full from "./assets/pics/numislatt/numislatt4BIG.webp";

import ratatati1 from "./assets/pics/ratatati/ratatati1.webp";
import ratatati2 from "./assets/pics/ratatati/ratatati2.webp";
import ratatati3 from "./assets/pics/ratatati/ratatati3.webp";
import ratatati4 from "./assets/pics/ratatati/ratatati4.webp";
import ratatati5 from "./assets/pics/ratatati/ratatati5.webp";
import ratatati1_full from "./assets/pics/ratatati/ratatati1BIG.webp";
import ratatati2_full from "./assets/pics/ratatati/ratatati2BIG.webp";
import ratatati3_full from "./assets/pics/ratatati/ratatati3BIG.webp";
import ratatati4_full from "./assets/pics/ratatati/ratatati4BIG.webp";
import ratatati5_full from "./assets/pics/ratatati/ratatati5BIG.webp";

export const services = [
  {
    subtitle: "Сайты и лендинги",
    description: (
      <>
        Создаём сайты под&nbsp;любые задачи: от&nbsp;простых лендингов
        до&nbsp;масштабных корпоративных порталов. Делаем адаптивно, быстро
        и&nbsp;с&nbsp;фокусом на&nbsp;конверсию.
      </>
    ),
    price: "от 35 000 ₽",
    time: "и 7 дней",
  },
  {
    subtitle: "Интернет-магазины и каталоги",
    description: (
      <>
        Разрабатываем e-commerce решения с&nbsp;удобной админкой, фильтрами,
        корзиной, оплатой и&nbsp;интеграцией с&nbsp;CRM.
        <br />
        Всё для&nbsp;продаж — из&nbsp;коробки.
      </>
    ),
    price: "от 60 000 ₽",
    time: "и 10 дней",
  },
  {
    subtitle: "Веб-приложения и сервисы",
    description: (
      <>
        Делаем интерактивные платформы, личные кабинеты, инструменты
        автоматизации и&nbsp;другие сложные системы. Подключаем базы данных,
        авторизацию, аналитику.
      </>
    ),
    price: "от 70 000 ₽",
    time: "и 14 дней",
  },
  {
    subtitle: "Телеграм-боты и мини-приложения",
    description: (
      <>
        Разрабатываем Telegram-ботов любого уровня сложности —
        от&nbsp;автоматизации задач до&nbsp;полноценных бизнес-инструментов.
        Поддержка Payments, API, AI.
      </>
    ),
    price: "от 30 000 ₽",
    time: "и 5 дней",
  },
  {
    subtitle: "UI/UX-дизайн и брендинг",
    description: (
      <>
        Придумываем логику, рисуем интерфейсы и&nbsp;собираем айдентику.
        Работаем на&nbsp;пересечении удобства и&nbsp;эстетики.
      </>
    ),
    price: "от 25 000 ₽",
    time: "и 5 дней",
  },
  {
    subtitle: "Поддержка и развитие",
    description: (
      <>
        Берём проекты на поддержку: улучшаем, оптимизируем, добавляем фичи,
        настраиваем аналитику. Быстро разбираемся в&nbsp;чужом коде,
        не&nbsp;боимся legacy.
      </>
    ),
    price: "от 2 500 ₽/час",
  },
];

export const stages = [
  {
    title: "Обрабатываем заявку",
    description: (
      <>
        Расскажите о&nbsp;вашей идее и&nbsp;оставьте контакт. <br />
        Чуть побольше текста накинул, чтобы&nbsp;лучше смотрелось
      </>
    ),
    cta: "Связаться",
    pic: bottle,
  },
  {
    title: <>Погружаемся в&nbsp;проект</>,
    description: (
      <>
        Мы выходим на&nbsp;связь, обсуждаем вашу идею, задаём уточняющие
        вопросы, изучаем рынок и&nbsp;цели проекта. <br />
        Вместе с&nbsp;вами формируем общее понимание задачи
      </>
    ),
    pic: lighthouse,
  },
  {
    title: "Прокладываем маршрут",
    description: (
      <>
        Создаём карту проекта: определяем этапы работ, <br />
        состав команды, технологии и&nbsp;сроки
      </>
    ),
    pic: map_man,
  },
  {
    title: "Разрабатываем продукт",
    description: (
      <>
        Проект переходит в&nbsp;активную фазу: создаём дизайн, пишем код,
        собираем интерфейсы. <br />
        Всё как строительство корабля — по&nbsp;частям, с&nbsp;любовью
        к&nbsp;деталям
      </>
    ),
    pic: development_boat,
  },
  {
    title: <>Запускаем и&nbsp;доводим до&nbsp;идеала</>,
    description: (
      <>
        Спускаем «корабль» на&nbsp;воду: проводим тесты, проверяем <br />
        на&nbsp;прочность, вносим правки и&nbsp;полируем продукт до&nbsp;блеска
      </>
    ),
    pic: launch_boat,
  },
  {
    title: <>Помогаем на&nbsp;всём пути</>,
    description: (
      <>
        После релиза остаёмся рядом: следим <br />
        за&nbsp;стабильностью, берём на&nbsp;себя поддержку, отвечаем <br />
        на&nbsp;вопросы и&nbsp;улучшаем продукт вместе с&nbsp;вами
      </>
    ),
    pic: final,
  },
];

export const stages_mobile = [
  {
    title: "Обрабатываем заявку",
    description: <>Расскажите о&nbsp;вашей идее и&nbsp;оставьте контакт.</>,
    cta: "Связаться",
    pic: bottle,
  },
  {
    title: "Погружаемся в проект",
    description: (
      <>
        Мы выходим на&nbsp;связь, обсуждаем вашу идею, изучаем рынок и&nbsp;цели
        проекта. Вместе с&nbsp;вами формируем общее понимание задачи
      </>
    ),
    pic: lighthouse,
  },
  {
    title: "Прокладываем маршрут",
    description: (
      <>
        Создаём карту проекта: определяем этапы работ, состав команды,
        технологии и&nbsp;сроки
      </>
    ),
    pic: map_man,
  },
  {
    title: "Разрабатываем продукт",
    description: (
      <>
        Проект переходит в&nbsp;активную фазу: создаём дизайн, пишем код,
        собираем интерфейсы.
      </>
    ),
    pic: development_boat,
  },
  {
    title: (
      <>
        Запускаем <br />и доводим до идеала
      </>
    ),
    description: (
      <>
        Спускаем «корабль» на&nbsp;воду: проводим тесты, проверяем <br />
        на&nbsp;прочность, вносим правки и&nbsp;полируем продукт до&nbsp;блеска
      </>
    ),
    pic: launch_boat,
  },
  {
    title: (
      <>
        Помогаем <br />
        на всём пути
      </>
    ),
    description: (
      <>
        После релиза остаёмся рядом: следим за&nbsp;стабильностью, берём
        на&nbsp;себя поддержку и&nbsp;улучшаем продукт вместе с&nbsp;вами
      </>
    ),
    pic: final,
  },
];

export const cases = [
  {
    title: "Ratatati",
    shortDescription: <>ERP-система для&nbsp;логистической компании</>,
    description: (
      <>
        ERP-система для&nbsp;управления логистикой: интерфейс для&nbsp;водителей
        и&nbsp;транспорта, документооборот, отчёты и&nbsp;Telegram-бот — всё
        для&nbsp;автоматизации и&nbsp;снижения нагрузки на&nbsp;сотрудников.
      </>
    ),
    aspectRatio: "4:3",
    images: [
      {
        srcPreview: ratatati1,
        srcFull: ratatati1_full,
        title: "Информация о водителе",
      },
      {
        srcPreview: ratatati2,
        srcFull: ratatati2_full,
        title: "Добавление водителя",
      },
      {
        srcPreview: ratatati3,
        srcFull: ratatati3_full,
        title: "Привязка ТС",
      },
      {
        srcPreview: ratatati4,
        srcFull: ratatati4_full,
        title: "Страница загрузки документов",
      },
      {
        srcPreview: ratatati5,
        srcFull: ratatati5_full,
        title: "Список водителей",
      },
    ],
  },
  {
    title: "Numislatt",
    shortDescription: (
      <>E-commerce система для&nbsp;продажи редких монет и&nbsp;банкнот</>
    ),
    description: (
      <>
        Полноценный e-commerce сервис с&nbsp;админкой: реализовали фильтры,
        оплату, подборки, добавление товаров и&nbsp;локализацию под&nbsp;разные
        страны.
      </>
    ),
    images: [
      {
        srcPreview: numislatt1,
        srcFull: numislatt1_full,
        title: "Главная",
      },
      {
        srcPreview: numislatt2,
        srcFull: numislatt2_full,
        title: "Страница товара",
      },
      {
        srcPreview: numislatt3,
        srcFull: numislatt3_full,
        title: "Оформление заказа",
      },
      {
        srcPreview: numislatt4,
        srcFull: numislatt4_full,
        title: "Процесс авторизации",
      },
    ],
  },
  {
    title: "Homeet",
    shortDescription: (
      <>
        Сервис для&nbsp;поиска жилья и&nbsp;соседей для&nbsp;студентов НИУ ВШЭ
      </>
    ),
    description: (
      <>
        Сервис для&nbsp;поиска жилья и&nbsp;соседей среди студентов НИУ ВШЭ:
        создали&nbsp;интерфейс, внедрили безопасную авторизацию и&nbsp;алгоритмы
        рекомендаций. В&nbsp;сотрудничестве&nbsp;с{" "}
        <a
          href="http://t.me/alexkovch"
          target="_blank"
          style={{ textDecoration: "underline" }}
        >
          alex kovch
        </a>{" "}
        создали бренд и визуальную айдентику.
      </>
    ),
    images: [
      {
        srcPreview: homeet1,
        srcFull: homeet1_full,
        title: "Профиль пользователя",
      },
      {
        srcPreview: homeet2,
        srcFull: homeet2_full,
        title: "Страница комнаты",
      },
      {
        srcPreview: homeet3,
        srcFull: homeet3_full,
        title: "Листинг комнат",
      },
      {
        srcPreview: homeet4,
        srcFull: homeet4_full,
        title: "Листинг соседей",
      },
    ],
    height: "650",
  },
  {
    title: "Стилеру",
    shortDescription: <>Сайт студенческой организации НИУ ВШЭ "Стилеру"</>,
    description: (
      <>
        Информационный лендинг для&nbsp;крупнейшего студенческого сообщества НИУ
        ВШЭ: разработали анимированный интерфейс, систему регистрации&nbsp;с
        рефералами и&nbsp;оптимизировали работу с медиа.
      </>
    ),
    images: [
      {
        srcPreview: styleru1,
        srcFull: styleru1_full,
        title: "Лендинг",
      },
      {
        srcPreview: styleru2,
        srcFull: styleru2_full,
        title: "Профиль пользователя",
      },
      {
        srcPreview: styleru3,
        srcFull: styleru3_full,
        title: "Редактирование профиля",
      },
      {
        srcPreview: styleru4,
        srcFull: styleru4_full,
        title: "Листинг участников",
      },
    ],
  },
];
